export default function Privacy() {
  return (
    <div className="min-h-screen bg-background text-foreground px-6 py-12 max-w-3xl mx-auto" style={{ paddingTop: "max(3rem, env(safe-area-inset-top))", paddingBottom: "max(3rem, env(safe-area-inset-bottom))" }}>
      <h1 className="text-2xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-sm text-muted-foreground mb-4">Last updated: March 21, 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold mb-2">What We Collect</h2>
          <p>
            HELLA Organized ("the app") connects to your Google account to provide email management, calendar integration, and task automation. When you sign in with Google, we access:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Gmail</strong> — We read and sync your email messages to display them in your inbox. We can send emails on your behalf when you use the delegation feature.</li>
            <li><strong>Google Calendar</strong> — We read and create calendar events to help you schedule tasks and meetings.</li>
            <li><strong>Profile information</strong> — Your name and email address for account identification.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">How We Use Your Data</h2>
          <ul className="list-disc ml-6 space-y-1">
            <li>Display your emails in the app's unified inbox</li>
            <li>AI-classify emails to filter noise from important messages</li>
            <li>Send delegation emails on your behalf when you explicitly request it</li>
            <li>Create and manage calendar events</li>
            <li>Extract action items from connected meeting transcript services (Fireflies, Plaud)</li>
          </ul>
          <p className="mt-2">We do not sell, share, or distribute your data to third parties. Your data is processed by AI (Anthropic's Claude) for classification and summarization — no human reviews your email content.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Data Storage</h2>
          <p>
            Your data is stored securely on Supabase (hosted on AWS). Email content, calendar data, and integration tokens are stored in your user-scoped account with row-level security. Only you can access your data.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Third-Party Services</h2>
          <ul className="list-disc ml-6 space-y-1">
            <li><strong>Supabase</strong> — Database and authentication</li>
            <li><strong>Anthropic (Claude AI)</strong> — Email classification, task extraction, AI chat</li>
            <li><strong>Vercel</strong> — Application hosting</li>
            <li><strong>Google APIs</strong> — Gmail and Calendar access</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Data Deletion</h2>
          <p>
            You can disconnect any integration at any time from Settings. When you disconnect Gmail, your stored email data is removed. To delete your entire account and all associated data, contact us at skyler@hellaintel.com.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-2">Contact</h2>
          <p>
            HELLA Intelligence LLC<br />
            Email: skyler@hellaintel.com<br />
            Website: hellaintel.com
          </p>
        </section>
      </div>
    </div>
  );
}
